import { X } from "lucide-react";
import { cn } from "./cn";

/* The one close control. Every dismissable surface in the app uses this so the
   gesture looks and behaves the same wherever a clinician meets it.

   It replaces two things that were both broken:

   - `assets/svgs/close-modal.svg`, which is not a vector at all — it is a raster
     image embedded as a `<pattern>` fill. Its pixels are white, so on a white
     modal the control was invisible, and no amount of `currentColor` or Tailwind
     text colour could ever have fixed it.
   - a scattering of `text-muted` X icons that read as disabled furniture.

   `warn` (#B4691F) at rest is the owner's call. It measures 4.22:1 on white, so
   it clears the 3:1 a graphical object needs comfortably, but it is under the
   4.5:1 required of small *text* — do not reuse this colour for a close label.

   On a dark ground warn drops to about 2.5:1, so `tone="onDark"` goes white
   instead. Pick the tone from the surface behind it, not by preference. */

const TONES = {
  default: "text-warn hover:bg-warn/10 focus-visible:ring-warn",
  onDark: "text-white/70 hover:bg-white/12 hover:text-white focus-visible:ring-accent-light",
};

const CloseButton = ({
  onClick,
  label = "Close",
  size = 18,
  tone = "default",
  className,
  ...props
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className={cn(
      "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-ns-sm",
      "transition-colors duration-ui ease-ui active:scale-[.98]",
      "focus-visible:outline-none focus-visible:ring-2",
      TONES[tone] ?? TONES.default,
      className
    )}
    {...props}
  >
    <X size={size} strokeWidth={2.5} />
  </button>
);

export default CloseButton;
